/*
This software is Copyright ©️ 2020 The University of Southern California. All Rights Reserved. 
Permission to use, copy, modify, and distribute this software and its documentation for educational, research and non-profit purposes, without fee, and without a written agreement is hereby granted, provided that the above copyright notice and subject to the full license file found in the root of this software deliverable. Permission to make commercial use of this software may be obtained by contacting:  USC Stevens Center for Innovation University of Southern California 1150 S. Olive Street, Suite 2300, Los Angeles, CA 90115, USA Email: accounting@stevens.usc.edu

The full terms of this copyright and license should always be found in the root directory of this software deliverable as "license.txt" and if these terms are not found with this software, please contact the USC Stevens Center for the full license.
*/

import * as actions from ".";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { GaimaTask, LearnerType, Lesson } from "../../../types";

export interface UseWithGaima {
  tasks: GaimaTask[];
  startPolling: (
    lesson: Lesson,
    learnerType: LearnerType,
    modelName?: string,
    maxIterations?: number,
    pipelineType?: string,
    useRealStreaming?: boolean
  ) => Promise<GaimaTask>;
  poll: (id: string) => Promise<GaimaTask>;
  editDocument: (id: string, document: string) => void;
}

export default function useWithGaima(): UseWithGaima {
  const { tasks } = useAppSelector((state) => state.gaima);
  const dispatch = useAppDispatch();

  async function startPolling(
    lesson: Lesson,
    learnerType: LearnerType,
    modelName?: string,
    maxIterations?: number,
    pipelineType?: string,
    useRealStreaming?: boolean
  ): Promise<GaimaTask> {
    return await dispatch(
      actions.startPolling({
        lesson,
        learnerType,
        initialDocument: lesson.resources[0].uri,
        learnerCharacteristics: learnerType.characteristics,
        modelName,
        maxIterations,
        pipelineType,
        useRealStreaming,
      })
    ).unwrap();
  }

  async function poll(id: string): Promise<GaimaTask> {
    return await dispatch(actions.poll(id)).unwrap();
  }

  function editDocument(id: string, document: string): void {
    dispatch(actions.modifyDocument({ id, document }));
  }

  return {
    tasks,
    startPolling,
    poll,
    editDocument,
  };
}
